/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./project-create-action-body').ProjectCreateActionBody} ProjectCreateActionBody
 */

/**
 * @typedef {import('./project-create-action-response').ProjectCreateActionResponse} ProjectCreateActionResponse
 */

/**
 * The path of the ProjectCreateAction action.
 */
export const projectCreateActionPath = new SweetPath('/api/project/project', { path: '{param}' });

/**
 * Creates a contextualized ProjectCreateAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createProjectCreateAction(axios) {
  /**
   * The projectCreateAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,body: ProjectCreateActionBody } }
   *
   * @returns {Promise<ProjectCreateActionResponse>}
   */
  function projectCreateAction({ headers = {}, parameters = {}, body } = {}) {
    const path = projectCreateActionPath.insert(parameters);

    return axios.post(path, body, { headers });
  }

  return projectCreateAction;
}
